import React from 'react'
type propsType = {
    type: string,
    msg: string,
}
const ApiResponeMessageBox = ({ type, msg }: propsType) => {
    return (
        <div className={`fixed z-20 top-10 right-5 animate-pulse text-white py-2 px-5 rounded-md ${type === 'success' && 'bg-primary-base'} ${type === 'error' && 'bg-optional'}`}>
            {msg}
        </div>
    )
}

export default ApiResponeMessageBox